import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { memo, useMemo } from 'react';
import { getNormalizedPercentageFromValue, percentageToCSSValue } from '@dtvgo/utils';
import { useSliderConfig } from './SliderContext.js';
import { SliderClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

var BORDER_RADIUS_BASE = 0.25;
var NO_BORDER_RADIUS = [0, 0];
function FillTemplate(_ref) {
  var className = _ref.className,
    style = _ref.style,
    value = _ref.value,
    lowerValue = _ref.lowerValue,
    flat = _ref.flat;
  var _useSliderConfig = useSliderConfig(),
    vertical = _useSliderConfig.vertical,
    maxValue = _useSliderConfig.maxValue,
    minValue = _useSliderConfig.minValue,
    flatSlider = _useSliderConfig.flat;
  var valueScaleFunction = vertical ? 'scaleY' : 'scaleX';
  var valueTranslateFunction = vertical ? 'translateY' : 'translateX';
  var lowerValuePercentage = getNormalizedPercentageFromValue(lowerValue, maxValue, minValue);
  var valuePercentage = getNormalizedPercentageFromValue(value, maxValue, minValue);
  var sizePercentage = valuePercentage - lowerValuePercentage;
  var valueStyle = useMemo(function () {
    var borderRadiusTransformed = BORDER_RADIUS_BASE / sizePercentage;

    // Values for elliptic border radius
    // Length of the semi-major axis of the ellpise: [horizontal, vertical]
    var borderRadiusValue = vertical ? ["".concat(BORDER_RADIUS_BASE, "em"), "".concat(borderRadiusTransformed, "em")] : ["".concat(borderRadiusTransformed, "em"), "".concat(BORDER_RADIUS_BASE, "em")];
    var lowerIsNearToMin = lowerValuePercentage < 0.01;
    var endIsNearToMax = valuePercentage > 0.99;
    var shouldRoundStart = lowerIsNearToMin ? !flatSlider : !flat;
    var shouldRoundEnd = endIsNearToMax ? !flatSlider : !flat;

    // Array sorted in the same order border-radius CSS property receives
    // Elliptic borderRadius don't work on separate properties (React issue (?))
    var borderRadiusProperties = [/* borderTopLeftRadius: */shouldRoundStart && !vertical || shouldRoundEnd && vertical ? borderRadiusValue : NO_BORDER_RADIUS, /* borderTopRightRadius: */shouldRoundEnd ? borderRadiusValue : NO_BORDER_RADIUS, /* borderBottomRightRadius: */shouldRoundStart && vertical || shouldRoundEnd && !vertical ? borderRadiusValue : NO_BORDER_RADIUS, /* borderBottomLeftRadius: */shouldRoundStart ? borderRadiusValue : NO_BORDER_RADIUS];
    return _objectSpread(_objectSpread({}, style), {}, {
      transform: "".concat(valueTranslateFunction, "(").concat(vertical ? '-' : '').concat(percentageToCSSValue(lowerValuePercentage), ") ").concat(valueScaleFunction, "(").concat(sizePercentage, ")"),
      borderRadius: "".concat(borderRadiusProperties.reduce(function (prev, current) {
        return "".concat(prev).concat(current[0], " ");
      }, ''), "/").concat(borderRadiusProperties.reduce(function (prev, current) {
        return "".concat(prev, " ").concat(current[1]);
      }, ''))
    });
  }, [lowerValuePercentage, flat, flatSlider, sizePercentage, style, valuePercentage, valueScaleFunction, valueTranslateFunction, vertical]);
  return /*#__PURE__*/jsx("div", {
    className: SliderClassNames.element('fill', className),
    style: valueStyle
  });
}
FillTemplate.defaultProps = {
  className: '',
  style: {},
  lowerValue: 0,
  value: 0,
  flat: false
};
var FillTemplate$1 = /*#__PURE__*/memo(FillTemplate);

export { FillTemplate$1 as default };
//# sourceMappingURL=FillTemplate.js.map
